import script from "./MobileDispatchPackaging.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileDispatchPackaging.vue?vue&type=script&setup=true&lang=js"

import "./MobileDispatchPackaging.vue?vue&type=style&index=0&id=294533b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-294533b8"]])

export default __exports__